var _g, _path, _path2, _path3, _circle, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 3,
    width: 30,
    height: 30,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 28,
    height: 28,
    rx: 9,
    stroke: "#60A4BF",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 23.6957L15.8056 28L19.1111 26.087V19.3913L27 17",
    stroke: "#EAEAEA",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24.5377L16.3054 19.0556L21.0277 22.6667L28.2499 16",
    stroke: "#9F9F9F",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73514 24.0284L9.99986 14.5004L13.9998 13.0004L27 17.5005",
    stroke: "#D1D1D1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 7.5,
    r: 5.5,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2 7.32558C24.2 6.28523 25.0059 5.44186 26 5.44186C26.9941 5.44186 27.8 6.28523 27.8 7.32558C27.8 8.36593 26.9941 9.2093 26 9.2093C25.0059 9.2093 24.2 8.36593 24.2 7.32558Z",
    fill: "#FF6138"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 7.32558C19 3.27977 22.134 0 26 0C29.866 0 33 3.27977 33 7.32558C33 10.8718 31.5143 13.53 29.9377 15.2899C29.1503 16.1689 28.3348 16.8306 27.6564 17.2761C27.3175 17.4986 27.0065 17.6713 26.7442 17.7908C26.5112 17.897 26.2356 18 26 18C25.7644 18 25.4888 17.897 25.2558 17.7908C24.9935 17.6713 24.6825 17.4986 24.3436 17.2761C23.6652 16.8306 22.8497 16.1689 22.0623 15.2899C20.4857 13.53 19 10.8718 19 7.32558ZM26 4.18605C24.3431 4.18605 23 5.59166 23 7.32558C23 9.0595 24.3431 10.4651 26 10.4651C27.6569 10.4651 29 9.0595 29 7.32558C29 5.59166 27.6569 4.18605 26 4.18605Z",
    fill: "#FF6138"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0059 26.3993C9.23152 26.3993 8.60156 25.7714 8.60156 24.9995C8.60156 24.2275 9.23152 23.5996 10.0059 23.5996C10.7803 23.5996 11.4103 24.2275 11.4103 24.9995C11.4103 25.7714 10.7803 26.3993 10.0059 26.3993Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0062 24.1999C10.4488 24.1999 10.8087 24.5586 10.8087 24.9998C10.8087 25.441 10.4488 25.7997 10.0062 25.7997C9.56365 25.7997 9.20374 25.441 9.20374 24.9998C9.20374 24.5586 9.56365 24.1999 10.0062 24.1999ZM10.0062 23C9.74274 23 9.48184 23.0518 9.23842 23.1523C8.99499 23.2529 8.77382 23.4002 8.58753 23.5859C8.40123 23.7717 8.25346 23.9922 8.15265 24.2348C8.05185 24.4775 7.99997 24.7376 8 25.0002C8.00003 25.2628 8.05195 25.5229 8.15281 25.7656C8.25366 26.0082 8.40148 26.2287 8.58781 26.4144C8.77414 26.6001 8.99535 26.7474 9.23879 26.8478C9.48223 26.9483 9.74314 27 10.0066 27C10.5388 26.9999 11.0491 26.7892 11.4253 26.4141C11.8016 26.039 12.0129 25.5302 12.0129 24.9998C12.0128 24.4694 11.8014 23.9607 11.425 23.5856C11.0487 23.2106 10.5384 22.9999 10.0062 23Z",
    fill: "#60A4BF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 2,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/Map_icon.b16d07cff1bcbf15ca63ad74d554da16.svg";
export { ForwardRef as ReactComponent };